import React from "react";
import { FaExclamationCircle } from "react-icons/fa";

const SaveDebtAlert = ({ isVisible, onCancel, onConfirm, clientName, debtValue }) => {
  if (!isVisible) return null;

  const hasDebt = parseFloat(debtValue) > 0;

  return (
    <div
      onClick={onCancel}
      style={{
        position: "fixed", inset: 0, zIndex: 50,
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: 16,
        background: "rgba(17,24,39,0.45)",
        backdropFilter: "blur(3px)",
        WebkitBackdropFilter: "blur(3px)",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          borderRadius: 16,
          border: "1px solid #e5e7eb",
          boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
          padding: "28px 24px",
          width: "100%",
          maxWidth: 360,
        }}
      >
        {/* Icon */}
        <div style={{
          width: 48, height: 48, borderRadius: "50%",
          background: hasDebt ? "#fff1f2" : "#f0fdf4",
          border: `1px solid ${hasDebt ? "#fecdd3" : "#bbf7d0"}`,
          display: "flex", alignItems: "center", justifyContent: "center",
          margin: "0 auto 16px",
        }}>
          <FaExclamationCircle style={{ color: hasDebt ? "#dc2626" : "#16a34a", fontSize: 20 }} />
        </div>

        {/* Title */}
        <h3 style={{ fontSize: 16, fontWeight: 500, color: "#111827", margin: "0 0 8px", textAlign: "center" }}>
          Salva saldo precedente
        </h3>

        {/* Message */}
        <p style={{ fontSize: 13, color: "#6b7280", lineHeight: 1.6, margin: "0 0 20px", textAlign: "center" }}>
          {hasDebt ? (
            <>
              Stai salvando un debito di{" "}
              <strong style={{ color: "#dc2626" }}>
                {parseFloat(debtValue).toFixed(2)} €
              </strong>{" "}
              per <strong style={{ color: "#111827" }}>{clientName}</strong>.
            </>
          ) : (
            <>
              Stai azzerando il saldo precedente per{" "}
              <strong style={{ color: "#111827" }}>{clientName}</strong>.
            </>
          )}
        </p>

        {/* Buttons */}
        <div style={{ display: "flex", gap: 10 }}>
          <button
            onClick={onCancel}
            style={{
              flex: 1, padding: "10px", borderRadius: 8,
              border: "1px solid #e5e7eb", background: "#f9fafb",
              color: "#374151", fontSize: 14, fontWeight: 500,
              cursor: "pointer", fontFamily: "inherit",
            }}
          >
            Annulla
          </button>
          <button
            onClick={onConfirm}
            style={{
              flex: 1, padding: "10px", borderRadius: 8,
              border: "none",
              background: hasDebt
                ? "linear-gradient(135deg, #dc2626, #ef4444)"
                : "linear-gradient(135deg, #16a34a, #22c55e)",
              color: "#fff", fontSize: 14, fontWeight: 500,
              cursor: "pointer", fontFamily: "inherit",
            }}
          >
            Conferma
          </button>
        </div>
      </div>
    </div>
  );
};

export default SaveDebtAlert;